import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { DealCard, HappyHour } from "@/components/Deals";
import { DealsGate } from "@/components/DealSignup";
import { CategoryLinks } from "@/components/InlineLinks";
import { DEALS, PAGES } from "@/lib/site";

const CRUMBS = [{ name: "Home", path: "/" }, { name: "Special Deals", path: "/special-deals" }];

export default function SpecialDeals() {
  return (
    <>
      <Seo {...PAGES.deals} path="/special-deals" crumbs={CRUMBS} />
      <PageHeader crumbs={CRUMBS} eyebrow="GasLight special deals" title="A deal for" highlight="your week" image="/img/store-3.webp" lead="Specials on select items Monday to Thursday and Sunday at our 14th Street shop, plus $10 pre-roll happy hour Monday to Thursday from 4 to 8 PM." />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20" data-testid="deals-page">
        <h2 className="h-section">This week's specials</h2>
        <div className="mt-8"><DealsGate /></div>
        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {DEALS.map((d, i) => <Reveal key={d.key} delay={0.04 * i}><DealCard d={d} /></Reveal>)}
        </div>
        <Reveal className="mt-4"><HappyHour /></Reveal>
        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-neutral-500" data-testid="deals-fine-print">
          Deals apply to select items only. Ask our team in store or call us for today's eligible products.
          Purchases require a valid 21+ ID and a medical cannabis patient registration — <Link to="/medical-card" className="font-bold text-brand-red" data-testid="deals-medical-card-link">get your medical card</Link>.
          Browse <CategoryLinks /> on the live menu.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/shop-all" className="btn-lime" data-testid="deals-shop-button">Shop now</Link>
          <Link to="/location" className="btn-outline" data-testid="deals-location-button">How to find us</Link>
        </div>
      </section>
    </>
  );
}
